<template>

  <div class="container page pwd-page">

    <van-nav-bar :title="$t('setting.set_money_pwd')" class="nav-bar" :border="false">

      <template #left>

        <van-icon name="arrow-left" @click="back()" />

      </template>

      <template #right>

        <span class="nav-right" @click="save()">{{ $t('setting.save') }}</span>

      </template>

    </van-nav-bar>

    <div class="pwd-form">

      <div class="pwd-row van-hairline--bottom">

        <span class="pwd-label">{{ $t('setting.old_pwd') }}</span>

        <input

          v-model="old_password"

          class="pwd-input"

          type="password"

          :placeholder="$t('setting.old_pwd_tip')"

        />

      </div>

      <div class="pwd-row van-hairline--bottom">

        <span class="pwd-label">{{ $t('setting.new_pwd') }}</span>

        <input

          v-model="o_new_password"

          class="pwd-input"

          type="password"

          :placeholder="$t('setting.new_pwd_tip')"

        />

      </div>

      <div class="pwd-row van-hairline--bottom">

        <span class="pwd-label">{{ $t('setting.new_pwd') }}</span>

        <input

          v-model="t_new_password"

          class="pwd-input"

          type="password"

          :placeholder="$t('setting.new_again_tip')"

        />

      </div>

    </div>

  </div>

</template>



<script>

export default {

  data() {

    return {

      o_new_password: '',

      t_new_password: '',

      old_password: ''

    }

  },

  methods: {

    back() {

      window.history.back()

    },

    save() {

      if (!this.o_new_password || !this.t_new_password || !this.old_password) {

        this.$toast.fail(this.$t('setting.prefect'))

        return false

      }

      if (this.o_new_password !== this.t_new_password) {

        this.$toast(this.$t('setting.pwd_error'))

        return false

      }

      this.$http({

        method: 'post',

        data: { paypassword: this.o_new_password },

        url: 'user_set_paypw'

      }).then(res => {

        if (res.code === 200) {

          this.$toast(res.msg)

          setTimeout(() => {

            localStorage.clear()

            this.$router.push('Login')

          }, 500)

        } else if (res.code === 401) {

          this.$toast(res.msg)

        }

      })

    }

  },

  created() {

    if (!localStorage.getItem('token')) {

      this.$router.push({ path: '/Login' })

    }

  }

}

</script>



<style lang="less" scoped>

@import '../../assets/css/base.css';

</style>

